<template>
    <div class="jambox">
        <div class="jambox-content" v-show="allSoundsLoaded()">
            <ul id="recordingslist"></ul>

            <div class="slider" v-for="(item, index) in audio">
                <label :for="'volume-white-' + index">{{ item.label }}</label>
                <input type="range"
                       min="0"
                       max="1"
                       step="0.01"
                       :value="item.options.volume"
                       @change="changeVolume(index, $event.target.value)"
                       :id="'volume-white-' + index"
                />
            </div>

            <div v-show="allSoundsLoaded()">
                <button v-on:click="play()" type="button">Play</button>
                <button v-on:click="stop()" type="button">Stop</button>
                <button v-on:click="record()" type="button">Record</button>
            </div>
        </div>

        <div class="jambox-loading" v-show="false === allSoundsLoaded()">

            Bestanden aan het inladen

            <div class="progress">
                <div class="progress-bar"
                     role="progressbar"
                     :style="'width: ' + loadingPercentage() + '%;'"
                     :aria-valuenow="loadingPercentage()"
                     aria-valuemin="0"
                     :aria-valuemax="soundsInQueue"
                >{{ loadingPercentage() }}%</div>
            </div>

        </div>
    </div>
</template>

<script>

    import Pizzicato from 'pizzicato';
    import Recorder from '../services/recorder';

    export default {

        props: {
            audio: {},
        },

        data() {
            return {
                group: {},
                loadingSoundsQueueCount: -1,
                soundsInQueue: 0,
                sounds: {},
            }
        },

        mounted() {

            this.loadSounds();

        },

        methods: {

            loadingPercentage() {
                var current = this.soundsInQueue - this.loadingSoundsQueueCount;
                var max = this.soundsInQueue;

                return ((current + 1) / max) * 100;
            },

            loadSounds() {
                var self = this;

                this.loadingSoundsQueueCount = Object.keys(this.audio).length;
                this.soundsInQueue = Object.keys(this.audio).length;
                this.group = new Pizzicato.Group();

                for (let _key in this.audio) {
                    let sound = new Pizzicato.Sound(this.audio[_key], function(item) {
                        self.loadingSoundsQueueCount--;
                        self.sounds[_key]['loaded'] = true;
                    });

                    this.sounds[_key] = sound;
                    this.group.addSound(sound);
                }
            },

            allSoundsLoaded() {
                return this.loadingSoundsQueueCount === 0;
            },

            record() {
                var self = this;

                this.group.stop();
                this.group.play();

                const ctx = Pizzicato.context;
                const source = Pizzicato.masterGainNode;
                source.connect(ctx.destination);
                const dest = ctx.createMediaStreamDestination();
                source.connect(dest);
                const recorder = new Recorder(source);
                recorder.record();


                setTimeout(function () {
                    recorder.stop();
                    self.createDownloadLink(recorder);
                    recorder.clear();
                }, 10000);
            },

            createDownloadLink(recorder) {
                recorder && recorder.exportWAV(function (blob) {
                    var url = URL.createObjectURL(blob);
                    var li = document.createElement('li');
                    var au = document.createElement('audio');
                    var hf = document.createElement('a');

                    au.controls = true;
                    au.src = url;
                    hf.href = url;
                    hf.download = new Date().toISOString() + '.wav';
                    hf.innerHTML = hf.download;
                    li.appendChild(au);
                    li.appendChild(hf);
                    recordingslist.appendChild(li);
                });
            },

            play() {
                this.group.play();

            },

            stop() {
                this.group.pause();
            },

            changeVolume(_key, value) {

                this.sounds[_key].volume = parseFloat(value);

            },
        }
    }
</script>
